import React from 'react';
import { Link } from 'react-router-dom';
import { trustOrgs } from '../../data/casinos';
import './Footer.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      {/* Safety Strip */}
      <div className="footer-safety-strip">
        <div className="container">
          <div className="safety-orgs">
            {trustOrgs.map((org) => (
              <a
                key={org.id}
                href={org.url}
                target="_blank"
                rel="noopener noreferrer"
                className="safety-org-link"
                title={org.name}
              >
                <img src={org.logo} alt={org.name} className="safety-org-logo" />
                <span className="safety-org-name">{org.name}</span>
              </a>
            ))}
            <div className="safety-age-badge">
              <span className="age-circle">18+</span>
              <span>Kun for voksne</span>
            </div>
          </div>
          <p className="safety-notice">
            Spil kan være vanedannende. Spil ansvarligt og kun for sjov. Hjælp og selvudelukkelse:&nbsp;
            <a href="https://www.stopspillet.dk/" target="_blank" rel="noopener noreferrer">StopSpillet.dk</a>
            &nbsp;·&nbsp;
            <a href="https://www.rofus.nu/" target="_blank" rel="noopener noreferrer">ROFUS.nu</a>
          </p>
        </div>
      </div>

      {/* Main Footer */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* Brand */}
            <div className="footer-brand">
              <div className="footer-logo">
                <span className="logo-mark-sm">TCD</span>
                <span className="footer-logo-name">TopCasinoDansk</span>
              </div>
              <p className="footer-about">
                TopCasinoDansk er en uafhængig dansk guide og sammenligningsportal for online casino. Vi er ikke en spiludbyder – vi er redaktionelle anmeldere, der hjælper danske spillere med at træffe informerede valg.
              </p>
              <p className="footer-disclosure">
                <strong>Affiliate-oplysning:</strong> Denne hjemmeside indeholder affiliate-links. Hvis du besøger et casino via vores links, modtager vi muligvis en provision. Dette påvirker ikke vores uafhængige vurderinger.
              </p>
            </div>

            {/* Navigation */}
            <div className="footer-col">
              <h4 className="footer-col-title">Navigation</h4>
              <ul className="footer-links">
                <li><Link to="/">Forside</Link></li>
                <li><Link to="/casino-guide">Casino Guide</Link></li>
                <li><Link to="/vores-metode">Vores Metode</Link></li>
                <li><Link to="/om-os">Om Os</Link></li>
                <li><Link to="/kontakt">Kontakt</Link></li>
                <li><Link to="/hjaelp">Hjælp & Support</Link></li>
              </ul>
            </div>

            {/* Legal */}
            <div className="footer-col">
              <h4 className="footer-col-title">Juridisk</h4>
              <ul className="footer-links">
                <li><Link to="/privatlivspolitik">Privatlivspolitik</Link></li>
                <li><Link to="/cookiepolitik">Cookiepolitik</Link></li>
                <li><Link to="/ansvarligt-spil">Ansvarligt Spil</Link></li>
              </ul>
              <h4 className="footer-col-title" style={{ marginTop: '1.5rem' }}>Hjælpelinjer</h4>
              <ul className="footer-links">
                <li><a href="https://www.stopspillet.dk/" target="_blank" rel="noopener noreferrer">StopSpillet.dk</a></li>
                <li><a href="https://www.rofus.nu/" target="_blank" rel="noopener noreferrer">ROFUS.nu</a></li>
                <li><a href="https://www.spillemyndigheden.dk/" target="_blank" rel="noopener noreferrer">Spillemyndigheden</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="container">
          <p className="footer-legal">
            © {currentYear} TopCasinoDansk.com – Alle rettigheder forbeholdes. Denne hjemmeside er udelukkende til informationsformål.
            TopCasinoDansk tilbyder ikke spil eller pengeindsatser. Spillere skal være mindst 18 år gamle. Spil er kun tilladt for dem,
            der er bosat i Danmark og ikke er udelukket fra spil via ROFUS. Reguleret af Spillemyndigheden.
          </p>
        </div>
      </div>
    </footer>
  );
}
